import {Routes} from 'constants/routes';

import Icon from 'components/Icon/Icon';
import {NavLink} from 'react-router-dom';

const AdminLinks = () => {
  return (
    <>
      <NavLink
        to={Routes.HOME}
        className={({isActive}) => (isActive ? 'sidebar__link sidebar__link--active' : 'sidebar__link')}
      >
        <Icon icon="dashboard" />
        Dashboard
      </NavLink>
      <NavLink
        to={Routes.PUB_PAGES}
        className={({isActive}) => (isActive ? 'sidebar__link sidebar__link--active' : 'sidebar__link')}
      >
        <Icon icon="pubs" />
        Pub Pages
      </NavLink>
      <NavLink
        to={Routes.EDITORS}
        className={({isActive}) => (isActive ? 'sidebar__link sidebar__link--active' : 'sidebar__link')}
      >
        <Icon icon="users" />
        Page Editors
      </NavLink>
      <NavLink
        to={Routes.BREWERIES}
        className={({isActive}) => (isActive ? 'sidebar__link sidebar__link--active' : 'sidebar__link')}
      >
        <Icon icon="breweries" />
        Breweries
      </NavLink>
      <NavLink
        to={Routes.BEERS}
        className={({isActive}) => (isActive ? 'sidebar__link sidebar__link--active' : 'sidebar__link')}
      >
        <Icon icon="beers-1" />
        Beers
      </NavLink>
      <NavLink
        to={Routes.BEER_STYLES}
        className={({isActive}) => (isActive ? 'sidebar__link sidebar__link--active' : 'sidebar__link')}
      >
        <Icon icon="beer-styles" />
        Beer Styles
      </NavLink>
    </>
  );
};

export default AdminLinks;
